// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lists {
    display: grid;
    margin: 32px auto;
    text-align: left;
    grid-row-gap: 20px;
}

.list-item {
    background-color: #252B48;
    box-shadow: 0 4px 4px 0 rgb(247, 233, 135);
    width: 100%;
    border-radius: 10px;
    border: 2px solid #F7E987;
    overflow: hidden;
} 

.list-item a {
    text-decoration: none;
    color: #fff;
    cursor: pointer;
}

.list-item:hover {
    -webkit-transform: translate(0, -10px);
    transform: translate(0, -10px);
    transition: transform 0.5s ease;
}

.list-item__content {
    padding: 16px;
}

.list-item__restaurant {
    font-size: 1em;
    color: #999;
}

.list-item__restaurant-rate {
    font-size: 1em;
    text-decoration: none;
}

.list-item__content h2 {
    font-weight: 600;
    margin-top: 10px;
    font-size: 30px;
    transition: 0.3s opacity;
}

.list-item__title:hover {
    opacity: 0.5;
}

.list-item__title a {
    text-decoration: none;
    color: inherit;
}

.list-item__description {
    margin-top: 10px;
    font-size: 15px;
    line-height: 1.5em;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.list-item__thumbnail {
    width: 100%;
    height: 300px;
    background-size: cover;
    object-fit: cover;
    object-position: center;
}

.list-thumbnail {
    position: relative;
}

.list-item_rate {
    background-color: #445069;
    top: 20px;
    right: 0;
    border-radius: 5px 0px 0px 5px;
    color: #F7E987;
    font-weight: 500;
    font-size: 16px;
    padding: 10px;
    position: absolute;
}

.list-city {
    font-size: 16px;
	text-transform: uppercase;
	font-weight: 500;
    color: #F7E987;
	text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/list.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;CAClB,yBAAyB;CACzB,gBAAgB;IACb,cAAc;CACjB,qBAAqB;AACtB","sourcesContent":[".lists {\n    display: grid;\n    margin: 32px auto;\n    text-align: left;\n    grid-row-gap: 20px;\n}\n\n.list-item {\n    background-color: #252B48;\n    box-shadow: 0 4px 4px 0 rgb(247, 233, 135);\n    width: 100%;\n    border-radius: 10px;\n    border: 2px solid #F7E987;\n    overflow: hidden;\n} \n\n.list-item a {\n    text-decoration: none;\n    color: #fff;\n    cursor: pointer;\n}\n\n.list-item:hover {\n    -webkit-transform: translate(0, -10px);\n    transform: translate(0, -10px);\n    transition: transform 0.5s ease;\n}\n\n.list-item__content {\n    padding: 16px;\n}\n\n.list-item__restaurant {\n    font-size: 1em;\n    color: #999;\n}\n\n.list-item__restaurant-rate {\n    font-size: 1em;\n    text-decoration: none;\n}\n\n.list-item__content h2 {\n    font-weight: 600;\n    margin-top: 10px;\n    font-size: 30px;\n    transition: 0.3s opacity;\n}\n\n.list-item__title:hover {\n    opacity: 0.5;\n}\n\n.list-item__title a {\n    text-decoration: none;\n    color: inherit;\n}\n\n.list-item__description {\n    margin-top: 10px;\n    font-size: 15px;\n    line-height: 1.5em;\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.list-item__thumbnail {\n    width: 100%;\n    height: 300px;\n    background-size: cover;\n    object-fit: cover;\n    object-position: center;\n}\n\n.list-thumbnail {\n    position: relative;\n}\n\n.list-item_rate {\n    background-color: #445069;\n    top: 20px;\n    right: 0;\n    border-radius: 5px 0px 0px 5px;\n    color: #F7E987;\n    font-weight: 500;\n    font-size: 16px;\n    padding: 10px;\n    position: absolute;\n}\n\n.list-city {\n    font-size: 16px;\n\ttext-transform: uppercase;\n\tfont-weight: 500;\n    color: #F7E987;\n\ttext-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
